
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorGpsFull as ObiSensorGpsFullElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-gps-full.js';
 
 
 

 
 export const ObiSensorGpsFull = createComponent({
   react: React,
   tagName: 'obi-sensor-gps-full',
   elementClass: ObiSensorGpsFullElement,
   events: {
     
   }
  });
 
 